import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigOptions, ConfigService } from '@wilson/config';
import { Address } from '@wilson/interfaces';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AddressesService {
  private readonly httpClient = inject(HttpClient);
  private readonly config = inject<ConfigOptions>(ConfigService);

  public getAddressById(id: string): Promise<Address> {
    return firstValueFrom(
      this.httpClient.get<Address>(`${this.config.host}/addresses/${id}`),
    );
  }
  public getAddressBySearch(address: Address): Promise<Address[]> {
    return firstValueFrom(
      this.httpClient.post<Address[]>(
        `${this.config.host}/addresses/search`,
        address,
      ),
    );
  }

  public createNewAddress(address: Address): Promise<Address[]> {
    return firstValueFrom(
      this.httpClient.post<Address[]>(`${this.config.host}/addresses`, {
        items: [address],
      }),
    );
  }
}
